import React from 'react';
var linkInLanguage = function linkInLanguage(targetLanguage, link) {
  if (link.match(/\/(cn|jp|en|br|es)\//)) {
    return link.replace(/\/(cn|jp|en|br|es)\//, "/".concat(targetLanguage, "/"));
  }
  return "/".concat(targetLanguage).concat(link);
};

/**
 * LanguageToggle toggles the language of a given site, then updates the URL to match that language
 */
var LanguageToggle = function LanguageToggle(_ref) {
  var translationContext = _ref.translationContext,
    updateSiteLanguage = _ref.updateSiteLanguage,
    language = _ref.language,
    children = _ref.children,
    path = _ref.path,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: className,
    onClick: function onClick(e) {
      if (_onClick) {
        _onClick(e);
      }
      updateSiteLanguage(language, translationContext).then(function () {
        return window.history.pushState({}, '', linkInLanguage(language, path));
      }).catch(function () {
        return window.location.assign(linkInLanguage(language, path));
      });
    }
  }, children);
};
export default LanguageToggle;